import React from 'react';
import ActivityLog from './activityLog';

export default class LoggingUserLogs extends React.Component {
  state = {
    page: 1,
    limit: 20,
    query: '',
    searchText: '',
    activityFilter: '',
  };

  componentDidMount() {
    this.fetchPage(1);
  }

  fetchPage = (page) => {
    const { fetchResourcePaginate, queryParams = {} } = this.props;
    const { limit, query, activityFilter } = this.state;
    this.setState({ page });
    fetchResourcePaginate('activity', undefined, {
      page,
      limit,
      search: query || '',
      action: activityFilter || '',
      ...queryParams,
    });
  };

  handleSearch = (text) => {
    this.setState({ query: text, searchText: text }, () => this.fetchPage(1));
  };

  handleFilter = (val) => {
    this.setState({ activityFilter: val }, () => this.fetchPage(1));
  };

  render() {
    const {
      activityPages = [],
      activityMeta = {},
      activityPageLoading = {},
      outlets,
      devices,
      devicesLoading,
    } = this.props.resources;

    const currentPage = activityPages.find((p) => p.page === this.state.page) || {};
    const activity = currentPage.activity || [];
    const loading = !!activityPageLoading[this.state.page];

    return (
      <div className="grid-container">
        <div className="grid-x grid-padding-x grid-padding-y align-left">
          <div className="cell large-10 medium-10">
            <h4 style={{ paddingLeft: '15px' }}>Activity Log</h4>
            <ActivityLog
              activity={activity}
              outlets={outlets}
              devices={devices}
              devicesLoading={devicesLoading}
              loading={loading}
              refresh={() => this.fetchPage(this.state.page)}
              searchActivity={this.handleSearch}
              onFilter={this.handleFilter}
              meta={activityMeta}
              page={this.state.page}
              onPageChange={this.fetchPage}
            />
          </div>
        </div>
      </div>
    );
  }
}